const translations = {
    document: 'Document',
    labelDocuments: 'Label Documents',
    product: 'Product',
    retrieved: 'Retrieved',
    revision: 'Revision'
};

export default translations;
